








































import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import UserOverview from '@/components/UserOverview.vue'
import { ContextState, User, Config, EditShippingAddress } from '@/store/context/contextTypes'
import { Button } from '@bambora/payment-ui-components'
import { hasProperty } from '@/utils/helpers'
import FormInput from '@/components/FormInput.vue'
import GetShippingFields from '@/utils/shippingFields/shippingFields'
import ShippingIcon from '@/assets/icons/shipping.svg'

const _CONTEXT_: string = 'context'

@Component({
  computed: {
    ...mapState({
      shippingAddressData: (state: any): EditShippingAddress => state.context.shippingAddressData,
      editShippingAddressData: (state: any): EditShippingAddress => state.context.editShippingAddressData,
      config: (state: any): User => state.context.config,
      editShippingErrors: (state: any): User => state.context.editShippingErrors
    })
  },
  components: {
    UserOverview,
    FormInput,
    Button
  }
})
export default class ShippingAddress extends Vue {
  config: Config
  editShippingAddressData: EditShippingAddress
  shippingEditFields: Array<object>
  editShippingErrors: object
  @State('context') context: ContextState
  @Action('setEditCustomShipping', { namespace: _CONTEXT_ }) setEditCustomShipping: any
  @Action('setEditShippingData', { namespace: _CONTEXT_ }) setEditShippingData: any
  @Action('setShippingData', { namespace: _CONTEXT_ }) setShippingData: any
  @Action('resetShippingAddress', { namespace: _CONTEXT_ }) resetShippingAddress: any

  beforeMount () {
    // We assign this to local state since we don't need to filter+sort all available fields based on config more than once
    this.shippingEditFields = this.identifyFields
  }

  get shippingIcon () {
    return ShippingIcon
  }

  // computed
  get identifyFields (): Array<object> {
    const { country } = this.config
    return GetShippingFields[country]()
  }

  get editShippingFields () {
    return this.shippingEditFields
  }

  // Do we have an registered error for the field id?
  isValid (input) {
    return !hasProperty(this.editShippingErrors, input.id)
  }

  handleInputChange (e, fieldIndex) {
    this.setEditShippingData({ key: e.target.id, value: e.target.value })
  }

  saveShippingAddressData () {
    this.setShippingData()
  }

  deleteShippingAddress () {
    this.resetShippingAddress()
  }
}
